import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import {
  TextField,
  Button,
  DateRangeField,
  MenuItem,
} from '../../../../2-component';
import { Grid } from '../../../../1-primative';
import ClientsAutocomplete from './clientsAutocomplete';
import { SubTradeSelectedUser } from './subTradeRequestsTypes';
import { GoalTypes } from '../../../../../interfaces';

type SubTradeRequestsFiltersProps = {
  client: SubTradeSelectedUser | null;
  setClient: (user: SubTradeSelectedUser) => void;
  trade: string;
  setTrade: (trade: string) => void;
  goal: string;
  setGoal: (goal: string) => void;
  rangeTradeDate: any[];
  setRangeTrade: (dates: any[]) => void;
  rangeSettlementDate: any[];
  setRangeSettlementDate: (dates: any[]) => void;
  showGoalFilter: boolean;
  state: string;
};

const SubTradeRequestsFilters = ({
  client,
  setClient,
  trade,
  setTrade,
  goal,
  setGoal,
  rangeTradeDate,
  setRangeTrade,
  rangeSettlementDate,
  setRangeSettlementDate,
  showGoalFilter,
  state,
}: SubTradeRequestsFiltersProps) => {
  const { t } = useTranslation(['rebalanceReportV2']);

  const handleClearFilters = () => {
    setClient({} as SubTradeSelectedUser);
    setTrade('ANY');
    setGoal('ANY');
    setRangeTrade([null, null]);
    setRangeSettlementDate([null, null]);
  };

  return (
    <>
      <Grid container gap={1} justifyContent='space-between' alignItems='center'>
        <Grid item xs={8}>
          <Grid container gap={1} alignItems='center' flexWrap='nowrap'>
            <Grid item xs={showGoalFilter ? 2 : 3}>
              <ClientsAutocomplete onChange={(user: SubTradeSelectedUser) => setClient(user)} />
            </Grid>
            {showGoalFilter && (
              <Grid item xs={2}>
                <TextField
                  select
                  fullWidth
                  label={t('subTradeRequests.goals')}
                  value={goal}
                  onChange={(e: any) => setGoal(e.target.value)}
                >
                  <MenuItem value='ANY'>{t('common.any')}</MenuItem>
                  {Object.keys(GoalTypes).map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <Grid item xs={showGoalFilter ? 2 : 3}>
              <TextField
                select
                fullWidth
                label={t('subTradeRequests.trade')}
                value={trade}
                onChange={(e: any) => setTrade(e.target.value)}
              >
                <MenuItem value='ANY'>{t('common.any')}</MenuItem>
                <MenuItem value='BUY'>{t('subTradeRequests.buy')}</MenuItem>
                <MenuItem value='SELL'>{t('subTradeRequests.sell')}</MenuItem>
              </TextField>
            </Grid>
            {state !== 'REQUESTED' && (
              <>
                <Grid item xs={showGoalFilter ? 2 : 3}>
                  <DateRangeField
                    fullWidth
                    label={t('subTradeRequests.createDateRange')}
                    value={rangeTradeDate.map((date) => (date ? dayjs(date).format('YYYY-MM-DD') : null)) as [string | null, string | null]}
                    onChange={(dates: [string | null, string | null]) => {
                      setRangeTrade(dates.map((date) => (date ? new Date(date) : null)));
                    }}
                  />
                </Grid>
                <Grid item xs={showGoalFilter ? 2 : 3}>
                  <DateRangeField
                    fullWidth
                    label={t('subTradeRequests.settlementDateRange')}
                    value={rangeSettlementDate.map((date) => (date ? dayjs(date).format('YYYY-MM-DD') : null)) as [string | null, string | null]}
                    onChange={(dates: [string | null, string | null]) => {
                      setRangeSettlementDate(dates.map((date) => (date ? new Date(date) : null)));
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        {['REQUESTED', 'UNSUCCESSFUL', 'COMPLETE'].includes(state) && (
          <Grid item>
            <Button variant="outlined" onClick={handleClearFilters} label={t('actions.clearFilters')} />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SubTradeRequestsFilters;
